export const animation = (uuid: string) => {
	return `https://rage.gift/cdn/animations/${uuid}.tgs`
}

export const icon = (uuid: string) => {
	return `https://rage.gift/cdn/icons/${uuid}.png`
}

export const caseIcon = (uuid: string, small?: boolean) => {
	return `https://rage.gift/cdn/cases/${small ? '160/' : ''}${uuid}.png`
}

export const avatarSm = (url: string) => {
	return url.replace('/320/', '/160/').replace('/bots/', '/bots/160/')
}
